import { useEffect, useRef } from "react";
import "./mapaDistribuidora.css";
import { useTienda } from "../../../contextTienda";

export default function MapaDistribuidora() {
  const mapRef = useRef(null);
  const { isMobile } = useTienda();

  useEffect(() => {
    if (!mapRef.current || !window.google) return;

    const map = new window.google.maps.Map(mapRef.current, {
      center: isMobile
        ? { lat: -30.779261083907915, lng: -57.996201442207884 }
        : { lat: -30.77616391118864, lng: -57.999463008388545 },
      zoom: 14,
      streetViewControl: false,
      mapTypeControl: false,
    });

    const marker = new window.google.maps.Marker({
      position: { lat: -30.78493481332365, lng: -57.990767643555714 },
      map,
      title: "Calvo Aluminios",
    });

    // 👉 Al hacer clic en el marcador, abrir la ficha oficial en Google Maps
    marker.addListener("click", () => {
      window.open("https://maps.app.goo.gl/1gWprV7G8bSDcQVY7", "_blank");
    });
  }, [isMobile]);

  return (
    <div
      ref={mapRef}
      className="mapaDistribuidora"
      style={{ height: "35rem", width: "50rem" }}
    ></div>
  );
}
